<template lang="pug">
.review-title
  .text-2xl.font-semibold {{ reviewAccountTitle }}
  template(v-if="isFetching")
    v-row.my-5(no-gutters)
      v-col.mr-4(v-for="x in 3" :key="x" cols="1")
        v-skeleton-loader(type="text@2")
  template(v-else-if="isError")
    .d-flex.align-center.my-4
      v-icon.mr-2(color="danger500") mdi-alert-circle
      .text-sm.danger500--text {{ $t('error_stats') }}
  template(v-else)
    .d-flex.mt-1.mb-6
      div.pr-5(v-for="item in displayList" :key="item.text")
        .d-flex.align-center
          .text-xl.pr-1.font-medium {{ item.numbers }}
          v-icon(v-if="item.icon" color="black" size="13") {{ item.icon }}
        .text-xs.font-normal.neutral500--text {{ item.text }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReviewTitle',
  props: {
    listingTab: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isFetching: false,
      isError: false,
      stats: {
        google_reviews: null,
        reviews: null,
        invites: null,
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      reviewAccount: 'review/getMainAccount',
      hasReviewAccount: 'review/hasFinishedSetup'
    }),
    reviewAccountTitle() {
      if (this.hasReviewAccount) {
        return this.reviewAccount.location_name
      }
      return this.company.name
    },
    displayList() {
      // Google review stats
      if (this.listingTab === 0) {
        return [
          {
            text: this.$t('google_review'),
            numbers: this.stats.google_reviews?.rating,
            icon: '$yzi-star-01-fill'
          },
          {
            text: this.$t('total_review'),
            numbers: this.stats.google_reviews?.total,
            icon: null
          },
          {
            text: this.$t('five_star_review'),
            numbers: this.stats.google_reviews?.star_count.five ? `${(this.stats.google_reviews?.star_count.five / this.stats.google_reviews?.total * 100).toFixed(0)}%` : '0%',
            icon: null
          }
        ]
      }
      // Feedback stats
      if (this.listingTab === 1) {
        return [
          {
            text: this.$t('all_ratings'),
            numbers: this.stats.reviews?.rating,
            icon: '$yzi-star-01-fill'
          },
          {
            text: this.$t('total_review'),
            numbers: this.stats.reviews?.total,
            icon: null
          },
          {
            text: this.$t('five_star_review'),
            numbers: this.stats.reviews?.star_count.five,
            icon: null
          },
          {
            text: this.$t('four_star_review'),
            numbers: this.stats.reviews?.star_count.four,
            icon: null
          },
          {
            text: this.$t('three_star_review'),
            numbers: this.stats.reviews?.star_count.three,
            icon: null
          },
          {
            text: this.$t('two_star_review'),
            numbers: this.stats.reviews?.star_count.two,
            icon: null
          },
          {
            text: this.$t('one_star_review'),
            numbers: this.stats.reviews?.star_count.one,
            icon: null
          }
        ]
      }
      // Invites
      return [
        {
          text: this.$t('total_review'),
          numbers: this.stats.invites?.total,
          icon: null
        },
        {
          text: this.$t('invited'),
          numbers: this.stats.invites?.sent,
          icon: null
        },
        {
          text: this.$t('new'),
          numbers: this.stats.invites?.new,
          icon: null
        }
      ]
    }
  },
  watch: {
    listingTab: {
      immediate: true,
      async handler(value) {
        switch (value) {
          case 0:
            if (!this.stats.google_reviews) {
              await this.fetchStats('google_reviews')
            }
            break;

          case 1:
            if (!this.stats.reviews) {
              await this.fetchStats('reviews')
            }
            break;

          case 2:
            if (!this.stats.invites) {
              await this.fetchStats('invites')
            }
            break;
        
          default:
            break;
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    async fetchStats(item) {
      this.isFetching = true
      if (!this.hasReviewAccount) {
        return
      }
      try {
        const { data } = await this.$axios.get(`/reviews/${this.company.slug}/${item}/stats`)
        this.stats[item] = data
      } catch (error) {
        this.isError = true
      } finally {
        this.isFetching = false
      }
    }
  },
}
</script>

<style scoped>
</style>